import React from 'react';
import './moreView.scss';
import {MonTextS18W600LH18Co111 } from '../../texts/fontText/montserrat/TextMon';

const MoreViewBTn = () => {
  return (
    <div className="moreView">
      <div className="btn-box flex jc-center ai-center">
        <MonTextS18W600LH18Co111 text={'More View'} />
        <img src="/seamansclub-news/assets/svg/down-arrow-white.svg" alt="" className="more-icon" />
      </div>
    </div>
  );
};

export default MoreViewBTn;
